import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('lg_admin_token');

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('lg_admin_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const login = async (username, password) => {
  const { data } = await adminApi.post('/admin/login', { username, password });
  localStorage.setItem('lg_admin_token', data.token);
  return data;
};

export const logout = () => {
  localStorage.removeItem('lg_admin_token');
  window.location.href = '/admin/login';
};

export const isAuthed = () => !!getToken();

export const getContent = async (section) => {
  const { data } = await adminApi.get(`/content/${section}`);
  return data.data;
};

export const setContent = async (section, data) => {
  const { data: r } = await adminApi.put(`/content/${section}`, { section, data });
  return r;
};

export const listVersions = async (section) => (await adminApi.get(`/admin/content-versions/${section}`)).data;
export const revertVersion = async (section, versionId) => (await adminApi.post(`/admin/content-revert/${section}/${versionId}`)).data;
export const listAudit = async () => (await adminApi.get('/admin/audit')).data;

export const getTranslationStatus = async (section) => (await adminApi.get(`/admin/translations/status/${section}`)).data;
export const prewarmTranslations = async (section) => (await adminApi.post(`/admin/translations/prewarm/${section}`)).data;

export const aiSeo = async ({ text, lang = 'it', keyword = '', mode = 'rewrite' }) => {
  const { data } = await adminApi.post('/admin/ai/seo', { text, lang, keyword, mode });
  return data;
};

export const suggestKeywords = async ({ text, current_keyword = '', section_label = '' }) => {
  const { data } = await adminApi.post('/admin/ai/suggest-keywords', { text, current_keyword, section_label });
  return data.keywords || [];
};

export const uploadImage = async (file, onProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await adminApi.post('/admin/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded / (e.total || 1)) * 100)),
  });
  return data;
};

export const listMedia = async () => (await adminApi.get('/admin/media')).data;
export const deleteMedia = async (id) => (await adminApi.delete(`/admin/media/${id}`)).data;
export const listMessages = async () => (await adminApi.get('/admin/contact-messages')).data;
export const deleteMessage = async (id) => (await adminApi.delete(`/admin/contact-messages/${id}`)).data;


export const buildMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
};
